import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

const Pagination = (props) => {
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    setItemOffset(0);
  }, [props.items, props.itemsPerPage]);

  useEffect(() => {
    const endOffset = itemOffset + props.itemsPerPage;
    props.setCurrentItems(props.items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(props.items.length / props.itemsPerPage));
  }, [itemOffset, props.itemsPerPage, props.items]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * props.itemsPerPage) % props.items.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-chevron-left`}></use>
            </svg>
          }
          nextLabel={
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-chevron-right`}></use>
            </svg>
          }
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={4}
          onPageChange={handlePageClick}
          containerClassName={"pagination justify-content-center col-12"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
          initialPage={0}
          forcePage={Math.floor(itemOffset / props.itemsPerPage)}
        />
      )}
    </>
  );
};
export default Pagination;
